import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/MainLayout';
import { createFactory } from '../../services/api';
import './FactoryRegisterPage.css';

function FactoryRegisterPage() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        code: '',
        location: '',
        address: '',
        manager: '',
        contact: '',
        email: '',
        description: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // API 형식에 맞게 데이터 변환
            const requestData = {
                factoryCode: formData.code,
                factoryName: formData.name,
                address: formData.address,
                latitude: null,
                longitude: null,
                managerName: formData.manager,
                managerPhone: formData.contact,
                managerEmail: formData.email,
                status: 'NORMAL', // 초기 상태는 항상 정상
                description: formData.description,
                lastInspectionDate: null
            };

            
            const result = await createFactory(requestData);

            alert('공장이 성공적으로 등록되었습니다.');
            navigate('/factory-list');
        } catch (err) {
            console.error('공장 등록 실패:', err);

            // 에러 메시지 상세 처리
            if (err.message.includes('already exists')) {
                alert('이미 존재하는 공장 코드입니다. 다른 코드를 사용해주세요.');
            } else {
                alert('공장 등록에 실패했습니다. 입력 정보를 확인해주세요.');
            }
        }
    };

    const handleCancel = () => {
        navigate('/factory-list');
    };

    return (
        <MainLayout>
            <div className="factory-register-container">
                {/* Header Section */}
                <div className="factory-register-header">
                    <div className="factory-register-header-left">
                        <div className="factory-register-title">공장 등록</div>
                        <p className="factory-register-subtitle">새로운 공장 정보 생성</p>
                    </div>
                </div>

                {/* Form Section */}
                <div className="factory-register-content">
                    <form onSubmit={handleSubmit}>
                        {/* 기본 정보 섹션 */}
                        <div className="factory-form-section">
                            <h3 className="factory-section-title">기본 정보</h3>
                            <div className="factory-form-grid">
                                <div className="factory-form-group">
                                    <label className="factory-form-label">
                                        공장명 <span className="factory-required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        className="factory-form-input"
                                        placeholder="공장명 입력"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="factory-form-group">
                                    <label className="factory-form-label">
                                        공장 코드 <span className="factory-required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="code"
                                        className="factory-form-input"
                                        placeholder="예: SEL-001"
                                        value={formData.code}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="factory-form-group">
                                    <label className="factory-form-label">
                                        위치 <span className="factory-required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="location"
                                        className="factory-form-input"
                                        placeholder="예: 서울특별시 금천구"
                                        value={formData.location}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="factory-form-group">
                                    <label className="factory-form-label">
                                        상세 주소 <span className="factory-required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="address"
                                        className="factory-form-input"
                                        placeholder="상세 주소 입력"
                                        value={formData.address}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        {/* 담당자 정보 섹션 */}
                        <div className="factory-form-section">
                            <h3 className="factory-section-title">담당자 정보</h3>
                            <div className="factory-form-grid">
                                <div className="factory-form-group">
                                    <label className="factory-form-label">
                                        담당자명 <span className="factory-required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="manager"
                                        className="factory-form-input"
                                        placeholder="담당자 이름 입력"
                                        value={formData.manager}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="factory-form-group">
                                    <label className="factory-form-label">
                                        연락처 <span className="factory-required">*</span>
                                    </label>
                                    <input
                                        type="tel"
                                        name="contact"
                                        className="factory-form-input"
                                        placeholder="010-0000-0000"
                                        value={formData.contact}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="factory-form-group">
                                    <label className="factory-form-label">
                                        이메일 <span className="factory-required">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        className="factory-form-input"
                                        placeholder="example@company.com"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="factory-form-group factory-form-group-full">
                                    <label className="factory-form-label">비고</label>
                                    <textarea
                                        name="description"
                                        className="factory-form-textarea"
                                        placeholder="추가 설명 입력"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        rows="4"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Form Actions */}
                        <div className="factory-form-actions">
                            <button type="button" className="factory-btn-secondary" onClick={handleCancel}>
                                취소
                            </button>
                            <button type="submit" className="factory-btn-primary">
                                공장 등록
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </MainLayout>
    );
}

export default FactoryRegisterPage;
